import { combineReducers } from 'redux';
import common from './common/reducer';
import middle from './middle/middle-reducer';
import kiddie from './kiddie/kiddie-reducer';
import teacher from './teacher/reducer';

export default combineReducers({
  common,
  middle,
  kiddie,
  teacher,
});
